import clsx, { type ClassValue } from 'clsx';
import { extendTailwindMerge } from 'tailwind-merge';

/**
 * Keep in sync with `theme.extend.fontSize` in `tailwind.config.ts`.
 *
 * Without this, tailwind-merge sees `text-biz-lg` as a text colour and drops either it or a real
 * colour class (`text-biz-primary-foreground`) from the same `cn()` call.
 */
export const BIZ_FONT_SIZES = ['biz-xs', 'biz-sm', 'biz-base', 'biz-lg', 'biz-xl', 'biz-2xl', 'biz-3xl'] as const;

const twMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      'font-size': [{ text: [...BIZ_FONT_SIZES] }],
    },
  },
});

/**
 * `cn` — the canonical class name combiner for the Business app.
 *
 * Merges Tailwind classes intelligently (last-wins for conflicting utilities)
 * while preserving falsy class filtering from clsx. Use this instead of
 * manual string concatenation so that conditional variants don't produce
 * duplicate-but-conflicting classes like `p-2 p-4`.
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
